import axios from 'axios'

const DraftService = {
  async get (params = {}) {
    return axios.get('ro/purchase-order/drafts', { params })
  },

  async show (id) {
    return axios.get(`ro/purchase-order/drafts/${id}`)
  },

  async post (params = {}) {
    return axios.post('ro/purchase-order/drafts', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`ro/purchase-order/drafts/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`ro/purchase-order/drafts/${data.id}`, { data })
  }
}

export default DraftService
